import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'zcs-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent {
  @Input() accept = '.bin';
  @Input() title = 'Drag & drop your file here';
  @Input() subtitle = 'or click to browse';
  @Input() selectedFile: File | null = null;

  @Output() fileSelected = new EventEmitter<File>();
  @Output() fileCleared = new EventEmitter<void>();

  isDragging = false;

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      this.handleFileSelection(file);
    }
  }

  onFileInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.handleFileSelection(input.files[0]);
    }
  }

  handleFileSelection(file: File) {
    // Validate file extension if accept is specified
    if (this.accept) {
      const extensions = this.accept.split(',').map(ext => ext.trim());
      const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();

      if (!extensions.some(ext => ext === fileExtension)) {
        // Invalid file type - emit null to trigger error handling in parent
        this.fileSelected.emit(file); // Parent will handle validation
        return;
      }
    }

    this.fileSelected.emit(file);
  }

  clearFile(event: Event) {
    event.stopPropagation();
    this.fileCleared.emit();
  }

  triggerFileInput(fileInput: HTMLInputElement) {
    fileInput.click();
  }

  formatFileSize(bytes: number): string {
    return (bytes / 1024 / 1024).toFixed(2);
  }
}
